import React, { useContext } from 'react';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import { DisplayForAdmin } from '@shoflo/polymer/helpers/DisplayForRole/DisplayForRole';
import UserContext from 'containers/contexts/UserContext.js';
import Tooltip from 'components/Tooltip';

const StyledDropdownToggle = styled(DropdownToggle)`
  transition: all 0.2s;
  background: transparent;
  color: #767676;
  border: 1px solid transparent;
  padding: 8px;
  border-radius: 5px;

  &:hover,
  &:focus {
    border: 1px solid #0095ff !important;
    background: none;
    color: #0095ff;
  }
`;

const StyledUncontrolledDropdown = styled(UncontrolledDropdown)`
  .dropdown-menu.show {
    width: 220px;
    left: auto !important;
    right: 0;
    transform: translate3d(0px, 34px, 0px) !important;
  }
`;

const StyledDropdownItem = styled(DropdownItem)`
  display: flex;
  align-items: center;
  gap: 4px;
`;
/**
 * items = [{ onClick, icon, title }]
 */
const DashItemMenu = ({ items }) => {
  const user = useContext(UserContext);

  const DropdownItems = items ? (
    items.map(item => {
      if (!item.onClick) return null;

      if (item.displayForAdmin) {
        return (
          <DisplayForAdmin
            eventId={item.eventId}
            teamId={item.teamId}
            inclueTeamAdmin={true}
            user={user}
            key={`dropdown-item-${item.title}`}
          >
            <StyledDropdownItem data-testid={item.title} onClick={item.onClick}>
              <FontAwesomeIcon icon={item.icon} />
              {item.title}
            </StyledDropdownItem>
          </DisplayForAdmin>
        );
      }
      return (
        <StyledDropdownItem
          data-testid={item.title}
          key={`dropdown-item-${item.title}`}
          onClick={item.onClick}
        >
          <FontAwesomeIcon icon={item.icon} />
          {item.title}
        </StyledDropdownItem>
      );
    })
  ) : (
    <span />
  );

  return (
    <StyledUncontrolledDropdown>
      <Tooltip id="dash-item-menu" title="Options" />

      <StyledDropdownToggle
        aria-label="Open options"
        aria-describedby="tip-dash-item-menu"
      >
        <FontAwesomeIcon icon={faEllipsisH} />
      </StyledDropdownToggle>
      <DropdownMenu data-testid="eventSettingsDropdown">
        {DropdownItems}
      </DropdownMenu>
    </StyledUncontrolledDropdown>
  );
};

export default DashItemMenu;
